document.addEventListener( 'DOMContentLoaded', () => {
	// noinspection MagicNumberJS
	class EXPANDER {
		static CLASS_NAME_EXPANDER_BLOCK = 'jtf__expanderblock'
		static CLASS_NAME_HEADER = '__header'
		static CLASS_NAME_CONTENT = '__content'
		static CLASS_NAME_TOGGLE = '--toggle'
		static CLASS_NAME_EXPAND = '--expand'
		static SELECTOR_CLASS_WP_ADMIN = '.wp-admin'
		static SELECTOR_CLASS_BLOCK = '.wp-block-jtf-jtf-expander'
		static ANIMATION_TIME = 500
		static TIMEOUT_DELAY = 1000
		static ICON_CLASS_MINUS = 'fa-circle-minus'
		static ICON_CLASS_PLUS = 'fa-circle-plus'

		constructor( instance ) {
			this.instance = instance
			this.init()
		}

		slideUp( element, duration, callback ) {
			element.style.height = element.scrollHeight + 'px'
			element.style.transitionProperty = 'height, margin, padding'
			element.style.transitionDuration = duration + 'ms'
			element.offsetHeight
			element.style.overflow = 'hidden'
			element.style.height = 0
			element.style.paddingTop = 0
			element.style.paddingBottom = 0
			element.style.marginTop = 0
			element.style.marginBottom = 0
			setTimeout( () => {
				element.style.display = 'none'
				element.style.removeProperty( 'height' )
				element.style.removeProperty( 'padding-top' )
				element.style.removeProperty( 'padding-bottom' )
				element.style.removeProperty( 'margin-top' )
				element.style.removeProperty( 'margin-bottom' )
				element.style.removeProperty( 'overflow' )
				element.style.removeProperty( 'transition-duration' )
				element.style.removeProperty( 'transition-property' )
				if ( callback ) {
					callback()
				}
			}, duration )
		}

		slideDown( element, duration, callback ) {
			element.style.removeProperty( 'display' )
			let display = window.getComputedStyle( element ).display
			if ( display === 'none' ) {
				display = 'block'
			}
			element.style.display = display
			const height = element.scrollHeight
			element.style.overflow = 'hidden'
			element.style.height = 0
			element.style.paddingTop = 0
			element.style.paddingBottom = 0
			element.style.marginTop = 0
			element.style.marginBottom = 0
			element.offsetHeight
			element.style.transitionProperty = 'height, margin, padding'
			element.style.transitionDuration = duration + 'ms'
			element.style.height = height + 'px'
			element.style.removeProperty( 'padding-top' )
			element.style.removeProperty( 'padding-bottom' )
			element.style.removeProperty( 'margin-top' )
			element.style.removeProperty( 'margin-bottom' )
			setTimeout( () => {
				element.style.removeProperty( 'height' )
				element.style.removeProperty( 'overflow' )
				element.style.removeProperty( 'transition-duration' )
				element.style.removeProperty( 'transition-property' )
				if ( callback ) {
					callback()
				}
			}, duration )
		}

		init() {
			const classExpanderBlock = EXPANDER.CLASS_NAME_EXPANDER_BLOCK
			const classStringHeader = EXPANDER.CLASS_NAME_HEADER
			const classStringContent = EXPANDER.CLASS_NAME_CONTENT
			const classStringToggle = EXPANDER.CLASS_NAME_TOGGLE
			const classStringExpand = EXPANDER.CLASS_NAME_EXPAND

			const toggleSelector = '.' + classExpanderBlock + classStringHeader + classStringToggle

			this.instance.addEventListener( 'click', ( e ) => {
				if ( e.target.closest( toggleSelector ) ) {
					const contentElem = this.instance.querySelector( '.' + classExpanderBlock + classStringContent )
					const toggleElem = this.instance.querySelector( toggleSelector )
					const classExpand = classExpanderBlock + classStringContent + classStringExpand

					if ( contentElem.classList.contains( classExpand ) ) {
						this.slideUp( contentElem, EXPANDER.ANIMATION_TIME, () => {
							const icon = toggleElem.querySelector( 'span i' )
							icon.classList.remove( EXPANDER.ICON_CLASS_MINUS )
							icon.classList.add( EXPANDER.ICON_CLASS_PLUS )
							toggleElem.setAttribute( 'aria-expanded', 'false' )
							contentElem.classList.remove( classExpand )
						} )
					} else {
						this.slideDown( contentElem, EXPANDER.ANIMATION_TIME, () => {
							const icon = toggleElem.querySelector( 'span i' )
							icon.classList.remove( EXPANDER.ICON_CLASS_PLUS )
							icon.classList.add( EXPANDER.ICON_CLASS_MINUS )
							toggleElem.setAttribute( 'aria-expanded', 'true' )
							contentElem.classList.add( classExpand )
						} )
					}
				}
			} )
		}
	}

	const wpAdmin = document.querySelector( EXPANDER.SELECTOR_CLASS_WP_ADMIN )
	if ( wpAdmin ) {
		setTimeout( () => {
			const blocks = document.querySelectorAll( EXPANDER.SELECTOR_CLASS_BLOCK )
			if ( blocks.length > 0 ) {
				blocks.forEach( ( block ) => {
					new EXPANDER( block )
				} )
			}
		}, EXPANDER.TIMEOUT_DELAY )
	} else {
		const blocks = document.querySelectorAll( EXPANDER.SELECTOR_CLASS_BLOCK )
		if ( blocks.length > 0 ) {
			blocks.forEach( ( block ) => {
				new EXPANDER( block )
			} )
		}
	}
} )
